var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 28,
    viewBox: "0 0 42 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card 1",
    clipPath: "url(#clip0_931_36032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.9177 -0.206055H3.08233C1.38272 -0.206055 0 1.17667 0 2.87628V25.1239C0 26.8235 1.38272 28.2063 3.08233 28.2063H38.9178C40.6174 28.2063 42.0001 26.8235 42 25.1239V2.87628C42 1.17667 40.6174 -0.206055 38.9177 -0.206055ZM40.1912 25.1239C40.1912 25.8261 39.6199 26.3975 38.9177 26.3975H3.08233C2.38014 26.3975 1.80879 25.8262 1.80879 25.1239V2.87628C1.80879 2.17409 2.38006 1.60274 3.08233 1.60274H38.9177C39.6199 1.60274 40.1912 2.174 40.1912 2.87628V25.1239Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.98001 18.2935H4.81651C4.31693 18.2935 3.91211 18.6984 3.91211 19.1979C3.91211 19.6973 4.31702 20.1023 4.81651 20.1023H8.98001C9.47958 20.1023 9.88441 19.6973 9.88441 19.1979C9.88441 18.6984 9.4795 18.2935 8.98001 18.2935Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.0835 18.2935H12.92C12.4205 18.2935 12.0156 18.6984 12.0156 19.1979C12.0156 19.6973 12.4205 20.1023 12.92 20.1023H17.0835C17.5831 20.1023 17.9879 19.6973 17.9879 19.1979C17.9879 18.6984 17.583 18.2935 17.0835 18.2935Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.187 18.2935H21.0235C20.524 18.2935 20.1191 18.6984 20.1191 19.1979C20.1191 19.6973 20.524 20.1023 21.0235 20.1023H25.187C25.6866 20.1023 26.0914 19.6973 26.0914 19.1979C26.0914 18.6984 25.6866 18.2935 25.187 18.2935Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.2906 18.2935H29.1271C28.6275 18.2935 28.2227 18.6984 28.2227 19.1979C28.2227 19.6973 28.6276 20.1023 29.1271 20.1023H33.2906C33.79 20.1023 34.195 19.6973 34.195 19.1979C34.195 18.6984 33.7901 18.2935 33.2906 18.2935Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.6802 22.3154H4.81651C4.31693 22.3154 3.91211 22.7203 3.91211 23.2198C3.91211 23.7193 4.31702 24.1242 4.81651 24.1242H19.6802C20.1798 24.1242 20.5846 23.7193 20.5846 23.2198C20.5846 22.7203 20.1798 22.3154 19.6802 22.3154Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.2345 8.31738H4.81651C4.31693 8.31738 3.91211 8.72229 3.91211 9.22178V13.139C3.91211 13.6386 4.31702 14.0434 4.81651 14.0434H10.2345C10.7341 14.0434 11.1389 13.6385 11.1389 13.139V9.22178C11.1389 8.72221 10.734 8.31738 10.2345 8.31738ZM9.33012 12.2346H5.7209V10.1262H9.33004L9.33012 12.2346Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M37.1852 5.08203H27.3653C26.8658 5.08203 26.4609 5.48694 26.4609 5.98643C26.4609 6.48592 26.8658 6.89082 27.3653 6.89082H37.1852C37.6846 6.89082 38.0896 6.48592 38.0896 5.98643C38.0896 5.48694 37.6848 5.08203 37.1852 5.08203Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_931_36032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.2ecd71d73c9f403a76465c9c1e2964d4.svg";
export { ForwardRef as ReactComponent };